import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BaseState } from "@base/entities/BaseEntities";
import { BaseComponent } from "@base/component/BaseComponent";
import { ServiceBagService } from "@base/component/ServiceBag";

/**
 * Example of usage:
 * <m4u-search [DebounceTime]="100" (OnSearch)="LoadListView($event)"></m4u-search>
 */
@Component({
    selector: 'm4u-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})
export class M4USearchComponent extends BaseComponent<BaseState>
{
    @Input() SearchText: string = '';
    @Input() Placeholder: string = this.RC('lblSearch');
    @Input() DebounceTime: number = 500;
    @Input() MinSymbols: number = 0;
    @Input() Min: number = 0;
    @Input() Max: number = 0;
    @Output() OnSearch = new EventEmitter<string>();

    constructor(A: ServiceBagService) {
        super(A, "M4USearchComponent", BaseState);
    }

    Search(force: boolean) {

        if (this.SearchText == null || this.SearchText == '') {
            this.SearchText = '';
            this.OnSearch.emit('');
            return;
        }

        if (this.MinSymbols > 0 && !force) {
            if (this.SearchText && this.SearchText.length >= this.MinSymbols) {
                this.OnSearch.emit(this.SearchText);
            }
            return;
        }

        this.OnSearch.emit(this.SearchText);
    }

    Clear(event?: any) {
        if (!event || !event.value) {
            this.SearchText = '';
            this.Search(true);
        }
    }
}
